import axios from 'axios'
import useNotification from '@/composables/useNotification.js'
import { attachTrackings } from './trackings'

export const api = async (config, { error: handleError } = { error: true }) => {
    try {
        const response = await axios(config)

        return response.data
    } catch (error) {
        if (!handleError || !error.response) {
            console.error('Unhandled API Error in network layer: ', error)
        } else {
            _handleError(error)
            attachTrackings('hotjar', 'api_error')
        }
        throw error
    }
}

function _handleError(error) {
    const { notification } = useNotification()

    if (error.response?.data?.errors) {
        Object.keys(error.response.data.errors).forEach((key) => {
            notification('error', error.response.data.errors[key].join(/\r?\n/))
            console.error(error.response.data.errors[key].join(/\r?\n/))
        })
    } else if (error.response?.data?.message) {
        notification('error', error.response.data.message)
        console.error(error.response.data.message)
    } else {
        notification('error', error)
        console.error(error)
    }
}
